export const APPEAL_FACETS = [
  { key: 'sensoryAppeal', label: 'Sensory', shortLabel: 'Sensory', colorClass: 'bg-amber-500', chipClass: 'bg-amber-500/10 text-amber-300 border-amber-500/20' },
  { key: 'auditoryAppeal', label: 'Auditory', shortLabel: 'Auditory', colorClass: 'bg-blue-500', chipClass: 'bg-blue-500/10 text-blue-300 border-blue-500/20' },
  { key: 'psychologicalAppeal', label: 'Psychological', shortLabel: 'Psych', colorClass: 'bg-purple-500', chipClass: 'bg-purple-500/10 text-purple-300 border-purple-500/20' },
  { key: 'tabooAppeal', label: 'Taboo', shortLabel: 'Taboo', colorClass: 'bg-wine-500', chipClass: 'bg-wine-500/10 text-wine-300 border-wine-500/20' },
  { key: 'powerAppeal', label: 'Power', shortLabel: 'Power', colorClass: 'bg-rose-500', chipClass: 'bg-rose-500/10 text-rose-300 border-rose-500/20' },
  { key: 'intimacyAppeal', label: 'Intimacy', shortLabel: 'Intimacy', colorClass: 'bg-pink-500', chipClass: 'bg-pink-500/10 text-pink-300 border-pink-500/20' },
  { key: 'humiliationAppeal', label: 'Humiliation', shortLabel: 'Humiliation', colorClass: 'bg-orange-500', chipClass: 'bg-orange-500/10 text-orange-300 border-orange-500/20' },
  { key: 'exposureAppeal', label: 'Exposure', shortLabel: 'Exposure', colorClass: 'bg-cyan-500', chipClass: 'bg-cyan-500/10 text-cyan-300 border-cyan-500/20' }
];

export const getAppealLensScore = (entity, key) => Number(entity?.[key] ?? 50);

export const rankAppealLenses = (entity) => (
  APPEAL_FACETS
    .map((facet) => ({
      ...facet,
      score: getAppealLensScore(entity, facet.key),
      displayScore: (getAppealLensScore(entity, facet.key) / 10).toFixed(1)
    }))
    .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))
);

export const getAppealProfileHighlights = (entity) => {
  const ranked = rankAppealLenses(entity);
  const [primary, ...rest] = ranked;
  const supporting = rest.filter((facet) => facet.score >= Math.max((primary?.score ?? 0) - 12, 60)).slice(0, 2);
  const notable = ranked.filter((facet) => facet.score >= 70).slice(0, 4);

  return {
    ranked,
    primary,
    supporting,
    notable
  };
};

export const describeAppealProfile = (entity) => {
  const { primary, supporting } = getAppealProfileHighlights(entity);

  if (!primary) return 'No appeal profile available yet.';

  if (supporting.length === 0) {
    return `Mostly a ${primary.label.toLowerCase()} draw.`;
  }

  if (supporting.length === 1) {
    return `Mostly a ${primary.label.toLowerCase()} draw, with some ${supporting[0].label.toLowerCase()} pull.`;
  }

  return `Mostly a ${primary.label.toLowerCase()} draw, with ${supporting[0].label.toLowerCase()} and ${supporting[1].label.toLowerCase()} appeal close behind.`;
};
